import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { PlusCircle } from "lucide-react";

import { CustomButton } from "@/components/ui/Buttons";
import {
  BrandCompetitorHeader,
  BrandList,
} from "@/pages/ProductCollections/components/CollectionFiltering";
import { useGetCartCompetitorNamesQuery } from "@/redux/feature/brandCart/brandCartApi";
import usePolling from "@/hooks/usePolling";

const BrandCartCompetitors = ({
  setIsManualCartCompetitorModalOpen,
}: {
  setIsManualCartCompetitorModalOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}) => {
  const { brandName } = useParams();

  const { pollingInterval } = usePolling({
    templateIds: ["manual_brand_competitor_fetch_completed"],
  });

  // API call
  const { data: brandsData = [] } = useGetCartCompetitorNamesQuery(
    { brand: brandName! },
    { pollingInterval }
  );

  useEffect(() => {
    // Optional: any effect based on processing status
  }, [brandsData?.meta?.isProcessing]);

  const brands = brandsData?.data ?? [];
  const isLoading = brandsData?.meta?.isProcessing;

  return (
    <div className="w-full bg-white border rounded-lg border-[#E4E7EC] p-4 sm:p-5">
      <BrandCompetitorHeader />

      <CustomButton
        onClick={() => setIsManualCartCompetitorModalOpen(true)}
        fontWeight="600"
        padding="8px 12px"
        variant="outline"
        color="#0D0D0D"
        border="0px"
        className="flex gap-x-2 sm:gap-x-3 items-center my-4 w-full sm:w-auto whitespace-nowrap"
      >
        <span>
          <PlusCircle className="text-[#000000] w-5 h-5 sm:w-6 sm:h-6" />
        </span>
        <span className="text-sm 2xl:text-base">Add a New Brand</span>
      </CustomButton>

      <div className="mt-4">
        <BrandList brands={brands} selectedBrand={null} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default BrandCartCompetitors;
